import { first, memoize } from 'lodash';
import { Provider, Role, UpdateStaffRole } from '../graphQL';

export const formatProviderName = ({
  firstName,
  lastName,
  postNominalTitles,
}: Pick<Provider, 'firstName' | 'lastName' | 'postNominalTitles' | 'personalTitle'>) => {
  let name = `${firstName} ${lastName}`;
  if (postNominalTitles) {
    name += `, ${postNominalTitles}`;
  }
  return name;
};

type SuperAdminCheck = Pick<Provider, 'role'> & { organizations: any[] };
export const isProviderSuperAdmin = (provider: SuperAdminCheck) =>
  (provider.role === Role.UniversityAdmin || provider.role === Role.UniversityReportingAdmin) &&
  first(provider.organizations)?.children.length > 0;

export const prettifyRole = memoize((uglyRole: string) => {
  // camelcase -> spaces & capitalize first letter
  return uglyRole.replace(/([A-Z])/g, ' $1').replace(/^./, s => s.toUpperCase());
});

export const getInitials = ({ firstName, lastName }: Pick<Provider, 'firstName' | 'lastName'>) =>
  `${firstName?.[0] ?? '-'}${lastName?.[0] ?? '-'}`;

export const roleToAccountInfo: Record<UpdateStaffRole, { title: string; description: string }> = {
  universityAdmin: {
    title: 'Admin',
    description: 'Can collaborate, refer students, and add new university roles.',
  },
  universitySupportingClinician: {
    title: 'Supporting Clinician',
    description: 'Can collaborate and see patient data, but cannot refer students.',
  },
  universityReferrer: {
    title: 'Referrer',
    description: 'Can refer new students, but cannot collaborate or see patient data.',
  },
  universityStaff: { title: 'Staff', description: 'Can refer new students AND collaborate.' },
  universityBeaconStaff: {
    title: 'Beacon Staff',
    description: 'Can see Beacon dashboards for the campus, but not individual student results.',
  },
  universityBeaconManager: {
    title: 'Beacon Manager',
    description: 'Can see Beacon dashboards for the campus and individual student results.',
  },
};
